import t from "../../../helpers/t";
import { Div2, Span } from "../styled_components/divs";
import { rbac } from "../index";
import React from "react";
import SwitchPaddle from "../../../components/switchpaddle";

const ItemWeb = (props) => {
  const {
    localVoucher,
    setInitialized,
    voucherPending,
    onChangeStatus,
    currentUrl,
    onRemoveVoucher,
    index,
  } = props;
  return (
    <>
      <div
        className={
          "inb-c-item inb-c-item--resource row show-for-large" +
          (localVoucher.status ? " not-marked" : " red-marked")
        }
        key={"web_div_row_" + localVoucher.id + "_standard"}
      >
        <div
          className="large-2 medium-2 small-4 column inb-order-big padding-1"
          id="order-id"
          key={"web_div_voucher_id_" + localVoucher.id}
        >
          <Span title={"ID"}>{localVoucher.name}</Span>
        </div>
        <div
          className="large-4 medium-4 small-8 column inb-order-big"
          id="description-voucher"
          key={"div_voucher_description_" + localVoucher.id}
        >
          <span title={localVoucher.description} className="text-nowrap">
            {localVoucher.description}
          </span>
        </div>
        <div
          className="large-1 medium-1 small-2 column"
          id="inb-unit"
          title={t("voucher_unit_" + localVoucher.voucher_unit)}
          key={"div_voucher_voucher_unit_" + localVoucher.id}
        >
          {t("voucher_unit_" + localVoucher.voucher_unit)}
        </div>
        <div
          className="large-1 medium-1 small-2 column"
          title={localVoucher.voucher_value}
          key={"div_voucher_voucher_value_" + localVoucher.id}
        >
          <span className="text-nowrap">{localVoucher.voucher_value}</span>
        </div>
        <div className="large-1 medium-1 small-2 medium-offset-0 column" id="">
          {voucherPending === localVoucher.id ? (
            <>
              <span>
                <img
                  alt="RollingLoader"
                  className="rollingLoader colorize-black"
                  src={"assets/img/rolling_loader.svg"}
                />{" "}
              </span>
            </>
          ) : (
            <SwitchPaddle
              name={localVoucher.id}
              disabled={rbac.hasPermission("editVoucher") ? "" : "disabled"}
              value={localVoucher.status}
              onChange={onChangeStatus}
              label={""}
            />
          )}
        </div>
        <div
          className="large-1 medium-3 small-6 medium-offset-0 column item-button-group"
          key={"div_voucher_edit_" + localVoucher.id}
        >
          {rbac.hasPermission("editVoucher") && (
            <div
              className="button-container-vouchers"
              key={"div_voucher_button_container_edit_" + localVoucher.id}
            >
              <a
                href={"/vouchers/" + localVoucher.id + currentUrl.search}
                title={t("edit")}
                key={"web_a_voucher_edit_" + localVoucher.id}
                data-inb-action-link="edit"
              >
                <button
                  type="button"
                  className="inb-round-btn hollow round float-left"
                  key={"web_a_button_voucher_edit_" + localVoucher.id}
                  style={{ width: "34px", height: "34px" }}
                >
                  <div className="inb-fi-edit" style={{ marginLeft: "-3px" }}>
                    {" "}
                  </div>
                </button>
              </a>
            </div>
          )}
          {rbac.hasPermission("removeVoucher") && (
            <div
              className="button-container-vouchers"
              key={"div_voucher_button_container_delete_" + localVoucher.id}
            >
              <a
                href="#"
                className="inb-reservation__pdf2"
                title={t("delete")}
                key={"a_voucher_delete_" + localVoucher.id}
                data-inb-action-link="delete"
              >
                <button
                  type="button"
                  className="inb-round-btn hollow round float-left"
                  key={"web_a_button_voucher_delete_" + localVoucher.id}
                  onClick={() => onRemoveVoucher(localVoucher)}
                  style={{ width: "34px", height: "34px" }}
                >
                  <div className="inb-fi-remove" style={{ marginLeft: "-3px" }}>
                    {" "}
                  </div>
                </button>
              </a>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ItemWeb;
